import React from 'react'
import { EditOutlined } from '@ant-design/icons'

const RowComponent = (props) => (
  <div className='flex items-center justify-between py-2 col-12 text-semibold'>
    {props.testo}
    <EditOutlined
      onClick={props.onIconClick}
      style={{
        fontSize: 24,
        padding: 4
      }}
    />
  </div>
)

export default RowComponent
